<template>
    <div class="item item-stone">
        <Icon
            v-if="stoneIcon"
            :icon="stoneIcon"
            class="icon-stone"
        />

        <div class="title-description">
            <h3 class="title">
                {{ stoneShapeAndWeight }}
            </h3>

            <div class="description">
                <span class="description-text">{{ stoneDescription }}</span>

                <span class="price">: {{ stonePrice }}</span>
            </div>
        </div>

        <div
            v-if="!fetchingRingBuilderSetMutation"
            class="remove-button"
            @click.prevent.stop="removeStone"
        >
            {{ t('ring_builder.remove') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import {
    getGemsApiShapeIcon,
    getMonolithShapeIcon,
} from '@/domain/stone/search/shape'
import { assertNever } from '@/helpers'
import type { Icons } from '@/components/ui/icon'
import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'
import { useI18n } from 'vue-i18n'
import Icon from '@/components/ui/icon/Icon.vue'
import { useRingBuilder } from '@/plugins/ring-builder.ts'

const props = defineProps<{
    data: RingBuilderStoneTypes
}>()

const {
    removeStone,
    stoneShapeAndWeight,
    stoneDescription,
    stonePrice,
    fetchingRingBuilderSetMutation,
} = useRingBuilder()

const stoneIcon = computed((): Icons | undefined => {
    const stone = props.data

    switch (stone.__typename) {
        case 'GemsApi_Stone':
            return getGemsApiShapeIcon(stone.shapeWithInfo.code)
        case 'NonSkuLabGrown':
        case 'NonSkuGemstone':
            return getMonolithShapeIcon(stone.shape.systemCode)
        default:
            return assertNever(stone, stone)
    }
})

const { t } = useI18n()
</script>

<style lang="scss" scoped src="./ringBuilderItem.scss"></style>
<style lang="scss" scoped>
.item-stone {
    .icon-stone {
        margin-right: 20px;
        width: 36px;
        height: 36px;
        font-size: 28px;
        line-height: 36px;
        color: $grey-400;

        &::before {
            display: flex;
            justify-content: center;
        }
    }

    .title-description {
        max-width: calc(100% - 100px);

        .description {
            display: flex;
            .description-text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
